import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import { ROOT_DIV_ID } from "shared/enum";
import { AppProvider } from "contexts/App";

import App from "./App";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById(ROOT_DIV_ID)!).render(
  <AppProvider>
    <App />
  </AppProvider>,
);
